import styles from "@/components/loading-skeletons.module.css";
import { JSX } from "react";

interface LoadingSkeletonsProps {
	widths: (string | undefined)[];
}

function LoadingSkeletons({ widths }: LoadingSkeletonsProps): JSX.Element {
	const skeletonElements = [];
	for (let i = 0; i < widths.length; i++) {
		skeletonElements.push(
			<div
				key={i}
				style={{
					width: widths[i],
				}}
			></div>,
		);
	}

	return (
		<div className={styles["loading-skeletons"]}>{skeletonElements}</div>
	);
}

export default LoadingSkeletons;
